module.exports = __webpack_public_path__ + "img/93.3864ff89.jpg";